import React from 'react';
import { cn } from '@/lib/utils';

interface ResponsiveGridProps {
  children: React.ReactNode;
  className?: string;
  cols?: {
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    '2xl'?: number;
  };
  gap?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  as?: keyof JSX.IntrinsicElements;
}

const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({
  children,
  className,
  cols = { sm: 1, md: 2, lg: 3, xl: 4, '2xl': 5 },
  gap = 'md',
  as: Component = 'div',
}) => {
  const gapClasses = {
    none: '',
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
    xl: 'gap-8',
  };

  const gridColsClasses = {
    sm: `grid-cols-${cols.sm || 1}`,
    md: `md:grid-cols-${cols.md || cols.sm || 1}`,
    lg: `lg:grid-cols-${cols.lg || cols.md || cols.sm || 1}`,
    xl: `xl:grid-cols-${cols.xl || cols.lg || cols.md || cols.sm || 1}`,
    '2xl': `2xl:grid-cols-${cols['2xl'] || cols.xl || cols.lg || cols.md || cols.sm || 1}`,
  };

  return (
    <Component
      className={cn(
        'grid',
        gridColsClasses.sm,
        gridColsClasses.md,
        gridColsClasses.lg,
        gridColsClasses.xl,
        gridColsClasses['2xl'],
        gapClasses[gap],
        className
      )}
    >
      {children}
    </Component>
  );
};

export default ResponsiveGrid;
